import { StripeConnectedAccountService } from '@modules/stripe/stripe-connected-account/stripe-connected-account-service';
import RelationToOneField from '@shared/fields/relation-to-one-field';
import RelationToManyField from '@shared/fields/relation-to-many-field';
import Permissions from '@security/permissions';

export class StripeConnectedAccountField {
  static relationToOne(name, label, options) {
    return new RelationToOneField(
      name,
      label,
      '/stripe-connected-account',
      Permissions.values.stripeConnectedAccountRead,
      StripeConnectedAccountService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.id,
        };
      },
      options,
    );
  }

  static relationToMany(name, label, options) {
    return new RelationToManyField(
      name,
      label,
      '/stripe-connected-account',
      Permissions.values.stripeConnectedAccountRead,
      StripeConnectedAccountService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.id,
        };
      },
      options,
    );
  }
}
